import { constants } from "redux/constants/redux-constants"

export const show_redirect_popup=(payload)=>{
    return {
            type: constants?.MOBILETAB?.SET_REDIRECT_POPUP,
            payload,
        }
}